import mixpanel from 'mixpanel-browser';

interface MixpanelConfig {
  token: string;
  debug?: boolean;
  api_host?: string;
}

class Analytics {
  private static instance: Analytics;
  private initialized = false;

  private constructor() {}

  static getInstance(): Analytics {
    if (!Analytics.instance) {
      Analytics.instance = new Analytics();
    }
    return Analytics.instance;
  }

  init(config: MixpanelConfig): void {
    if (this.initialized) return;

    const environment = import.meta.env.VITE_ENVIRONMENT || 'development';

    mixpanel.init(config.token, {
      debug: config.debug || false,
      api_host: config.api_host || 'https://api.mixpanel.com',
      persistence: 'localStorage',
      ignore_dnt: false,
      cross_subdomain_cookie: false,
      secure_cookie: true,
      track_pageview: true,
      verbose: environment === 'development' ? false : true,
    });

    this.initialized = true;
  }

  track(eventName: string, properties?: Record<string, any>): void {
    if (!this.initialized) return;

    mixpanel.track(eventName, {
      ...properties,
      timestamp: new Date().toISOString(),
      platform: 'web'
    });
  }

  trackPageView(pageName: string, properties?: Record<string, any>): void {
    this.track('Page Viewed', { page_name: pageName, ...properties });
  }
}

export const analytics = Analytics.getInstance();
